import DigitalMarketingServicePage from '../digital-marketing/DigitalMarketingServicePage';
import { getDigitalMarketingService } from '../digital-marketing/services';

const GoogleAdsPpc = () => {
  const service = getDigitalMarketingService('google-ads-ppc');
  if (!service) return null;
  return <DigitalMarketingServicePage service={service} />;
};

export default GoogleAdsPpc;
